import React, { useState } from 'react';
import './ClientLogin.css'
import { useAuth } from '../contexts/AuthContext';
import { useHistory } from 'react-router-dom'

function ClientLogin() {
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const { login } = useAuth()
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)
    const history = useHistory()

    async function handleSubmit(e) {
        e.preventDefault()

        try {
            setError("")
            setLoading(true)
            await login(email, password)
            // do I need to create a different url for each client or only 1 for all????
            history.push("/client/dashboard")
        } catch {
            setError("Failed to log in")
        }

        // setLoading(false)
    }

    return (
        <div id="login">
            <h1>Log In</h1>
            <form onSubmit={handleSubmit}>
                <label>Username:</label>
                <input type='email' onChange={e => setEmail(e.target.value)} required />
                <label>Password:</label>
                <input type='password' onChange={e => setPassword(e.target.value)} required />
                <button disabled={loading} type="submit">Log in</button>
                {error}
            </form>
        </div>
    )
}

export default ClientLogin
